export const ruleURL = "https://www.ra9plus.jp/rule"
